const ENDPOINT = 'POSTautomaticDeleteRelease';
function postAutomaticDeleteRelease(gateway, params) {
    return gateway.get(postAutomaticDeleteRelease.endpoint, params);
}
postAutomaticDeleteRelease.endpoint = ENDPOINT;

export { postAutomaticDeleteRelease as default };
//# sourceMappingURL=postAutomaticDeleteRelease.js.map
